<template>
    <div class="add-to-cart"
        :class="{ 'has-variations': this.hasVariationsProduct.length > 0 }"
    >
        <slot></slot>

        <quantity-input :mu-prop="mu"></quantity-input>

        <add-to-cart
            :button-text="buttonText"
            :route="route"
            :product-id-prop="productId"
            :has-variations-product="!!hasVariationsProduct.length"
        >
        </add-to-cart>
    </div>
</template>

<script>
    import QuantityInput from '../../inputs/QuantityInput';
    import AddToCart from '../../buttons/AddToCart';

    export default {
        props: {
            buttonText: {
                required: true,
                type: String
            },
            route: {
                required: true,
                type: String
            },
            productId: {
                required: true,
                type: String
            },
            hasVariationsProduct: {
                required: true,
                type: String
            },
            mu: {
                required: true,
                type: String,
            }
        },

        components: {
            AddToCart,
            QuantityInput,
        }
    }
</script>
